import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LockFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LockFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M18.5 9.25v-1.5c0-3.58-2.92-6.5-6.5-6.5s-6.5 2.92-6.5 6.5v1.5h-2v8.5c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5v-8.5h-2Zm-5.5 7.5c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2Zm-4.5-7.5v-1.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v1.5h-7Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default LockFilled;